import EELogo from "../../assets/brand/End_of_an_Era_Logo.svg";
import { RoleSwitcher } from '../RoleSwitcher';

export default function Header() {
  return (
    <header
      id="app-header"
      className="w-full border-b border-stone-200 bg-white"
    >
      {/* Header row (70px) */}
      <div className="h-[70px] px-5">
        {/* Desktop: left + right */}
        <div className="hidden h-full lg:grid grid-cols-[1fr_1fr] items-center">
          {/* Left */}
          <div className="min-w-0 h-full flex items-center justify-start overflow-hidden">
            <div className="max-h-full flex items-center leading-none scale-90 origin-left">
              <img
                src={EELogo}
                alt="End of an Era logo"
                className="h-32 w-52 object-contain"
              />
            </div>
          </div>

          {/* Right: min-w-0 so long role labels truncate instead of growing the header */}
          <div className="flex h-full min-w-0 items-center justify-end">
            <RoleSwitcher />
          </div>
        </div>

        {/* Mobile: left + right */}
        <div className="lg:hidden h-full flex items-center justify-between gap-3">
          {/* Left */}
          <div className="min-w-0 flex items-center overflow-hidden">
            <img
              src={EELogo}
              alt="End of an Era logo"
              className="h-[32px] w-auto max-w-[140px] object-contain"
            />
          </div>

          {/* Right: cap width so logo keeps space; min-w-0 allows trigger text to truncate */}
          <div className="flex min-w-0 max-w-[55%] justify-end sm:max-w-[50%]">
            <RoleSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
}